
// export const BASE_API_URL = 'http://localhost:8080/baseproject/api';
export const BASE_API_URL = 'api/';
export const AUTH_TOKEN_NAME = 'token-ei';
